<template>
  <!-- 分类绑定商品 -->
  <div class="classifyGoods">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button
          type="primary"
          @click="handleChooseGoods"
          icon="el-icon-circle-plus-outline"
          >添加商品</el-button
        >
        <el-button
          :disabled="selectedList.length == 0"
          type="danger"
          icon="el-icon-scissors"
          @click="handleRemoveBind"
        >
          解绑商品</el-button
        >
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="请输入商品名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ArticleId"
        align="center"
        show-overflow-tooltip
        label="商品ID"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="GoodsName"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="DrugSpec"
        label="规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PackageUnit"
        label="单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="GoodsCode"
        label="商品编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="DrugFactory"
        label="产地"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 商品表格 -->
    <el-dialog
      title="商品列表"
      :visible.sync="goodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入商品名称"
            v-model="goodsName"
            @keydown.native.enter="getGoodsList(1)"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getGoodsList(1)"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="goodsList"
        border
        tooltip-effect="dark"
        height="300px"
        :row-class-name="tableRowClassName"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品名称"
        >
        </el-table-column>
        <!-- <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
        </el-table-column> -->
        <el-table-column
          prop="specification"
          label="商品规格"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="packingNnit"
          label="包装单位"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="producer"
          label="生产厂家"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <!-- 使用返回的类名判断，和表格的方法一样 -->
            <el-button
              v-if="tableRowClassName(scope) != ''"
              type="danger"
              style="padding: 2px 3px"
              plain
              @click="handleDelGoods(scope)"
              >删除</el-button
            >
            <el-button
              v-else
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleGoodsItem(scope)"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
      <div slot="footer">
        <el-button type="warning" @click="handleResetGoods">清空</el-button>
        <el-button type="primary" @click="handleSubmitGoods">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "classifyGoods",
  data() {
    return {
      entId: "", //机构id
      /**表格数据 */
      tableData: [],
      selectedList: [], //选中的商品
      /**搜索表单 */
      searchForm: {
        name: "",
      },
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**批量绑定商品 */
      addGoodsForm: {
        name: "", //分类名称
        id: "", //分类id
        list: [], //{id、name}
      },
      goodsName: "", //检索使用，商品名称
      goodsDialog: false, //dialog
      goodsList: [], //查询到的商品列表
      /**分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,
    };
  },
  mounted() {
    // 接收路由跳转传递的参数
    if ("id" in this.$route.query) {
      this.addGoodsForm.id = this.$route.query.id;
      this.addGoodsForm.name = this.$route.query.title;
    }
    this.entId = window.localStorage.getItem("entId");
    this.getTableData(1);
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    handleSearch() {
      this.getTableData(1);
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        categoryId: this.addGoodsForm.id,
        searchVal: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };

      this.$request({
        method: "post",
        url: "/Management/GoodsAdmin/GetGoodsCategoryList",
        dataType: "json",
        data,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.list;
            this.allPage = res.toTal;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    // 选择数据事件
    selectionChange(section) {
      this.selectedList = section;
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },

    /********* 商品添加 ***********/
    /**打开商品列表弹框 */
    handleChooseGoods() {
      this.goodsDialog = true;
      this.addGoodsForm.list = [];
    },

    /**获取表格 */
    getGoodsList(num) {
      this.currPage2 = num == 1 ? 1 : this.currPage2;
      let data = {
        type: "GoodsList",
        category: "0",
        attribute: "0",
        status: "2",
        strWhere: this.goodsName,
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        promtype: "",
        promstatus: "99",
        goodsPic: "99",
        spStatus: "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage2 = res.recordCount;
          this.goodsList = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.goodsList.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**选中某一个商品 */
    handleGoodsItem({ row }) {
      // 判断数组中是否存该条数据
      let repeat = this.addGoodsForm.list.some((item) => item == row.id);
      if (repeat) {
        this.$message({
          message: "该商品已存在",
          type: "warning",
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
        this.addGoodsForm.list.push(row.articleId);
      }
    },

    /**删除选中的某一个商品 */
    handleDelGoods({ row }) {
      let index = this.addGoodsForm.list.indexOf(row.articleId);
      this.addGoodsForm.list.splice(index, 1);
    },

    /**清空添加的商品 */
    handleResetGoods() {
      this.$confirm("确定清空吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.addGoodsForm.list = [];
        })
        .catch((e) => {
          console.log(e);
        });
    },

    /**商品绑定 */
    /**提交商品信息 */
    handleSubmitGoods() {
      if (this.addGoodsForm.list.length == 0) {
        this.$message({
          message: "暂未绑定商品",
          type: "error",
        });
        return;
      }
      this.$confirm("确定提交吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          method: "post",
          url: "/GoodsAdmin/SaveGoodsCategoryList",
          data: {
            entId: this.entId,
            categoryId: this.addGoodsForm.id,
            goodsStr: this.addGoodsForm.list.join(),
          },
        })
          .then((res) => {
            let type = "success";
            if (res.success) {
              this.goodsDialog = false;
              this.addGoodsForm.list = [];
              this.getTableData(1);
            } else {
              type = "error";
            }

            this.$message({
              message: res.message,
              type,
            });
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },

    /**表格数据选中状态判断 */
    tableRowClassName({ row }) {
      if (this.addGoodsForm.list.indexOf(row.articleId) > -1) {
        return "success-row";
      }

      return "";
    },

    /**商品解绑 */
    handleRemoveBind() {
      if (this.selectedList.length == 0) {
        this.$message({
          message: "暂未选择商品",
          type: "error",
        });
        return;
      }

      this.$confirm("确定解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request({
            method: "post",
            url: "/Management/GoodsAdmin/DltGoodsCategory",
            data: {
              categoryId: this.addGoodsForm.id,
              goodsList: this.selectedList.map((item) => item.ArticleId).join(),
            },
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                this.getTableData(1);
              } else {
                type = "error";
              }

              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.classifyGoods {
  width: 100%;
  height: 100%;
}

.couponView {
  width: 100%;
  height: 100%;
  list-style: none;
}

.couponView > li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  list-style: none;
}

.couponTitle {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}

.couponText {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #ccc;
  line-height: 40px;
}
</style>
